/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { OrderClass } from '../models/order-class';
import { orderClassGetorderclass } from '../fn/order-class/order-class-getorderclass';
import { OrderClassGetorderclass$Params } from '../fn/order-class/order-class-getorderclass';

@Injectable({ providedIn: 'root' })
export class OrderClassService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `orderClassGetorderclass()` */
  static readonly OrderClassGetorderclassPath = '/orderclass/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderClassGetorderclass()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderClassGetorderclass$Response(params?: OrderClassGetorderclass$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrderClass>>> {
    return orderClassGetorderclass(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderClassGetorderclass$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderClassGetorderclass(params?: OrderClassGetorderclass$Params, context?: HttpContext): Observable<Array<OrderClass>> {
    return this.orderClassGetorderclass$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OrderClass>>): Array<OrderClass> => r.body)
    );
  }

}
